import "./lib/public-path";
import "requestidlecallback-polyfill";

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "lazysizes/plugins/bgset/ls.bgset.js";
import "lazysizes/plugins/bgset/ls.bgset.min.js";
import "./lib/maestro/login-submit-event.js";
import "./lib/maestro/logout-event.js";
import aos from "aos";
import app from "./lib/app";
import * as tablescapeComponents from "../tablescape";

import Vue from "vue";
import { Plugin } from "vue-fragment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "./vue/config/validator";
import "./vue/config/components";
import { store } from "./vue/config/store";
import vClickOutside from "v-click-outside";
import PortalVue from "portal-vue";

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
import { subscribeUpdateCart } from "./vue/store/cart/subscribe.js";

function getThemeEnv({ theme = {}, shop = "" } = {}) {
  const { role } = theme;
  const [prefix] = shop.split(".");
  let suffix = "preview";
  if (role === "main") {
    suffix = "production";
  } else if (role === "development") {
    suffix = role;
  }
  return `${prefix}-${suffix}`;
}

function getSentryConfig() {
  const config = {
    allowUrls: [/cdn.shopify.com/],
    denyUrls: [/cdn.shopify.com\/shopifycloud/],
    dsn: "https://933eaee9c2d64acb86f67af1bdd05021@o1239492.ingest.sentry.io/6390852",
    environment: getThemeEnv(Shopify),
    initialScope: {
      shop: Shopify?.shop,
      theme: Shopify?.theme,
    },
    integrations: [
      new BrowserTracing({
        tracingOrigins: ["localhost", /^yotpo\.com/],
      }),
    ],
    release: `our-place@${process.env.RELEASE_SHA}`,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.05,
  };

  return config;
}

function configureSentry() {
  const config = getSentryConfig();

  if (!config.environment.endsWith("production")) {
    console.group?.("Sentry Config");
    console.info?.(config);
    console.groupEnd?.();
  }

  if (typeof window !== "undefined") {
    window.__SENTRY_CONFIG__ = config;
  }

  Sentry.init(config);
}

configureSentry();

const vueBlackList = ["/challenge"];

if (!vueBlackList.includes(window.location.pathname)) {
  Vue.use(Plugin);
  Vue.component("ValidationProvider", ValidationProvider);
  Vue.component("ValidationObserver", ValidationObserver);
  Vue.use(vClickOutside);
  Vue.use(PortalVue);

  Vue.prototype.window = window;

  // eslint-disable-next-line no-new
  new Vue({
    el: "#app",
    store,
  });

  subscribeUpdateCart();
}

app.add({ ...tablescapeComponents });
app.mount(["data-component", "data-tbsp-component"]);

window.lazySizesConfig = window.lazySizesConfig || {};
window.picoApp = app;

setTimeout(() => {
  aos.init();
}, 1500);

// add class on body if user is tabbing through the site
window.addEventListener("keydown", function (e) {
  if (e.code === "Tab") {
    document.querySelector("body").classList.add("accessible");
  }
});

document.addEventListener("shopify:section:load", () => {
  app.mount(["data-component", "data-tbsp-component"]);
});
